
import ResetZoomButton from '@components/ResetZoomButton'
import { useZoomContext } from '@routes/Panorama/ZoomContext'

function PanoResetZoomButton() {
  const { resetZoom, isZoomed } = useZoomContext()

  return (
    <ResetZoomButton
      resetZoom={resetZoom}
      showButton={isZoomed}
    />
  )
}

export default PanoResetZoomButton